import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../../Components/InputAHSF";
import { use, useEffect } from "react";
import { GetLengthReportStageAndReportingPhase } from "../../../Redux/Reducers/ReportStage/ReportingPhase";
import { StartProgressReport } from "../../../Redux/Reducers/ReportStage/StartProgressReport";

const ProgressReportInformation = (props) => {
  const dispatch = useDispatch();   
  useEffect(() => {
    dispatch(
      GetLengthReportStageAndReportingPhase({ reportId: props.reportId })
    );
  }, []);
  const ReportingPhase = useSelector(
    (state) => state.ReportingPhaseReducer.ReportingPhase
  );



  return (
    <>
      {ReportingPhase?.reportingPhaseName ? (
        <>
          <div className="form-grid">
            <InputAHSF
              fieldsName="ReportStageName"
              show={true}
              disabled={true}
              onChange={(e) => {
                //   setInformationAboutResearcherList({
                //     ...InformationAboutResearcherList,
                //     roleInResearch: e.target.value,
                //   });
              }}
              defaultValue={ReportingPhase?.reportingPhaseName}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />

            <InputAHSF
              fieldsName="ReportDurationName"
              show={true}
              disabled={false}
              onChange={(e) => {
                props.setReportDuration(e.target.value);
              }}
              defaultValue={""}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ProgressReportInformation;
